export enum BusinessModuleType {
  BEAUTY = 'beauty',
  // WELLNESS = 'wellness',
  // HEALTH = 'health'
}

export enum BeautyTypes {
  NAILS = 'NAILS',
  BEAUTY_SALOON = 'BEAUTY_SALOON'
}
